// Environment variables from .env files
export const BASE_API_URL = import.meta.env.VITE_API_URL;
export const BASE_SQULA_API_URL = import.meta.env.VITE_SQULA_API_URL;
export const WSS_URL = import.meta.env.VITE_WSS_URL;
export const BASE_URL = import.meta.env.VITE_RESOURCES_URL;
export const FRONTEND_URL = import.meta.env.VITE_FRONTEND_URL;
export const GTM_CONTAINER_ID = import.meta.env.VITE_GTM_ID;
export const GA4_TAG_ID = import.meta.env.VITE_GA4_TAG_ID;
export const APP_ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT;
export const TYPO_CHECKER_TOKEN = import.meta.env.VITE_TYPO_CHECKER_TOKEN;
export const MARKETING_URL = import.meta.env.VITE_MARKETING_URL;
export const BRAND_NAME = import.meta.env.VITE_BRAND_NAME;
export const BASENAME = import.meta.env.VITE_BASENAME;
export const BUGSNAG_API_KEY = import.meta.env.VITE_BUGSNAG_API_KEY;
export const BUILD_VERSION = import.meta.env.VITE_BUILD_VERSION;
export const LOGOUT_REDIRECT_URL = `${FRONTEND_URL}/uitloggen`;
export const AUTH_URL = `${FRONTEND_URL}/oauth2/auth`;
export const IS_ADMIN = import.meta.env.VITE_BUILD_TARGET === 'admin';
export const WRAPPED_FEATURE_ENABLED = import.meta.env.VITE_WRAPPED_FEATURE_ENABLED === 'true';
export const BRIDGE_ENTRANCE_ENABLED = import.meta.env.VITE_BRIDGE_ENTRANCE_ENABLED === 'true';
export const PHASER_DEV_TOOLS_ENABLED = import.meta.env.VITE_PHASER_DEV_TOOLS_ENABLED === 'true';

// Authentication cookie configuration
export const AUTHENTICATION_COOKIE_DOMAIN = import.meta.env.VITE_AUTHENTICATION_COOKIE_DOMAIN;
export const AUTHENTICATION_COOKIE_SUFFIX = import.meta.env.VITE_AUTHENTICATION_COOKIE_SUFFIX;

// Parent password feature flag
export const CHECK_PARENT_PASSWORD = import.meta.env.VITE_CHECK_PARENT_PASSWORD === 'true';

export const IS_MOBILE_DEVICE =
	/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

interface DeviceTypeState {
	type: 'ios' | 'other' | undefined;
	touch: boolean | undefined;
}

export const DEVICE_TYPE: DeviceTypeState = {
	type: undefined,
	touch: undefined,
};

export const COOKIES = {
	accessToken: 'token',
	coupon: 'coupon',
	deviceToken: 'deviceToken',
	lastCorrectStreak: 'lastCorrectStreak',
	lastGclidTag: 'lastGclidTag',
	lastPageSlug: 'lastPageSlug',
	loggedIn: 'loggedIn',
	renewTime: 'renewTime',
	temporaryToken: 'temporaryToken',
	tokenValidUntil: 'token_valid_until',
	secureSession: '__Secure-session',
	redirectedToDailyGoal: 'redirectedToDailyGoal',
	aiTutorAccessToken: 'jwt-token-chat-app',
	parentPasswordVerified: 'parent_password_verified',
};

export const IS_MOBILE_VIEW = window.innerWidth < 768;
export const IS_TABLET_VIEW = window.innerWidth < 1024;
export const IS_DESKTOP_VIEW = window.innerWidth >= 1024;

export const MIN_DAY = 1;
export const MAX_DAY = 31;
export const MIN_YEAR = 1900;
export const MAX_YEAR = new Date().getFullYear();
export const MIN_PASSWORD_LENGTH = 5;
export const MIN_SIGN_UP_PASSWORD_LENGTH = 8;

export const SEARCH_PATH = '/search';

export const UTM_TAGS_TTL_DAYS = 1;

export const IMAGES_EXTENSIONS = [
	'image/png',
	'image/jpeg',
	'image/jpg',
	'image/gif',
	'image/svg+xml',
];

export const FILES_EXTENSIONS = [
	'application/doc',
	'application/docx',
	'application/pdf',
	'application/txt',
	'application/xlsx',
	'application/xls',
	'application/csv',
];

export const MAX_IMAGE_SIZE = 5000000;

export const MAX_FILE_SIZE = 5000000;

export const MAX_ATTACHMENTS = 10;

export const exerciseTypeCodesNext = {
	OPEN_ENDED: 'Question::OpenEnded',
	DICTATE: 'Question::Dictation',
	IN_YOUR_MIND: 'Question::InYourMind',
	MULTIPLE_CHOICE: 'Question::MultipleChoiceSingleAnswer',
	THE_BLANKS: 'Question::FillInTheBlanks',
	OPEN_MULTIPLE: 'Question::OpenQuestionMultipleAnswers',
	DICTATE_MULTIPLE: 'Question::DictationMultipleChoice',
	MULTIPLE_CHOICE_MULTIPLE_ANSWERS: 'Question::MultipleChoiceMultipleAnswers',
};

export const EXERCISE_VIEW_MODES = {
	REGULAR: 'regular',
	PREVIEW: 'preview',
	REPORT: 'report',
	REPLAY: 'replay',
};

export const APPLE_STORE_LINK = 'https://apps.apple.com/nl/app/wrts-woordjes-leren/id1191740855';

export const GOOGLE_PLAY_STORE_LINK =
	'https://play.google.com/store/apps/details?id=nl.wrts.mobiel';

export const PUNCTUATION_CHARACTERS = [',', '-', '.', '!', '?', '_', '+', ':'];

export const ACCESS_TOKEN_EXPIRATION_DAYS = 365;

export const IS_PRODUCTION_ENVIRONMENT = !['staging', 'localhost'].some((element) =>
	FRONTEND_URL.includes(element),
);

export const IS_LOCAL_ENVIRONMENT = FRONTEND_URL.includes('localhost');

export const LAST_CORRECT_STREAK_DAYS = 2;

export const TYPEFORM_SCRIPT_URL = '//embed.typeform.com/next/embed.js';

export const FRONTEND_ROUTES = {
	HOME: '/',
	ACTIVITY: '/activiteit',
	BRIDGE: '/brugklas',
	BRIDGE_AGENDA: '/brugklas/agenda',
	BRIDGE_MAP: '/brugklas/map/:roomId',
	BRIDGE_PLAYLIST: '/brugklas/playlist/:roomId/:taskType/:taskId',
	DAILY_GOAL: '/doel-gehaald',
	EXERCISE: '/doel/:section/:id',
	EXERCISE_REPORT: '/activiteit/:id/:questionId',
	EXERCISE_REPLAY: '/activiteit/replay/:id/:questionId',
	GOAL_SETTINGS: '/doel-instellen',
	LOGIN: '/inloggen',
	NEW_SCHOOL_YEAR: '/groep-aanpassen',
	ONBOARDING_CHOOSE_GRADE: '/groep-kiezen',
	ONBOARDING_SAVE_CHILD_NAME: '/naam-aanmaken',
	ONBOARDING_SAVE_PASSWORD: '/wachtwoord-aanmaken',
	PROGRESS: '/voortgang',
	PROGRESS_DETAILS: '/voortgang/:id/:slug',
	REPORT: '/activiteit/:id',
	SAVE_CHILD_NAME: '/naam-toevoegen',
	STICKERS_ONBOARDING: '/uitleg-stickers',
	FREE_PLAY: '/wereld',
	FREE_PLAY_CATEGORY: '/wereld/:id/:slug',
	FREE_PLAY_EXERCISE: '/wereld/:categoryId/:category/:id/:section',
	FREE_PLAY_ACHIEVEMENTS: '/wereld/paspoort',
	FREE_PLAY_CATEGORY_ACHIEVEMENTS: '/wereld/paspoort/:categoryName',
	SETTINGS: '/instellingen',
	WRAPPED: '/hoogtepunten',
};

export const ROUTES_API = {
	ACTIVITY_REPORT: 'users/activity_report',
	PLAYED_DAYS: 'users/played_days',
	GET_TOKEN: 'auth/get_token',
	RESET_PASSWORD: 'password/do_reset',
	RESET_PASSWORD_REQUEST: 'password/request_reset',
	NOTIFICATION_DEVICES: 'users/notification_devices',
	NOTIFICATION_DEVICES_REMOVE: 'users/notification_devices/remove',
	QUESTIONS_EXPLANATIONS: 'questions/explanations',
	EXERCISE: `user_learning_path_sections/:id`,
	QUESTION_ANSWER: 'playlist_section_answers',
	STORE_TIME: `playlist_section_answers/:answerId`,
	INSTRUCTION_FEEDBACK: 'instruction_feedbacks',
	UPDATE_USER: 'users/:userId',
	FINISH_LEARNING_PATH_SECTION: 'user_learning_path_sections/:playlistId/finish',
	DAILY_REPORT: 'users/daily_report',
	USER_GOAL_REFLECTIONS: 'user_goal_reflections',
	USER_GOAL_REFLECTIONS_VALUATIONS: 'user_goal_reflections/valuations',
	DAYGOAL_STICKERS_LIST: 'user_stickers/daygoal_list',
	USER_STICKERS: 'user_stickers',
	USER_STICKERS_LIST: 'user_stickers/list',
	COLLECT_REWARD: 'user_stickers/:id/collect_reward',
	UPDATE_REWARD: 'user_stickers/:id/update_reward',
	DAYGOAL_SUMMARY: 'progress/day_goal_summary',
	WEEK_GOAL_LIST: 'user_learning_paths/weekgoal_list',
	GET_USER_DATA: 'get_user_data',
	GOAL_SUBJECTS: 'goals/subjects',
	SESSION_LENGTH_OPTIONS: 'session_length_options',
	USER_WEEK_GOALS: 'users/user_week_goals',
	USER_WEEK_GOALS_CURRENT: 'users/user_week_goals/current',
	USER_SESSION_LENGTHS: 'users/user_session_lengths',
	USER_GOALS: 'user_goals',
	USER_LEARNING_PATHS: 'user_learning_paths',
	USER_LEARNING_PATH_SECTION_POSITIONS: 'user_learning_path_section_positions',
	GENERATE_USER_LEARNING_PATH: 'user_goals/generate_path',
	PROGRESS_OVERVIEW: 'progress/overview',
	SEND_EVENT: 'send_event',
	INVALIDATE_TOKEN: 'auth/invalidate_token',
	USER_EXPERIMENT: 'public/experiments/:experimentName',
	NOTIFICATIONS: 'users/notifications',
	NOTIFICATION_STATUS: 'users/notifications/:notificationId',
	GRADES: 'admin/grades',
	SET_PASSWORD: 'set_pwd',
	GET_AUDIO: 'external_services/speak',
	USERS_EXPERIMENT_TIMES: 'user_experiment_times',
	AUTONOMY_EXPERIMENT: 'public/experiments/experiment_2025_Q2_autonomy',
	FREE_PLAY_CATEGORIES: 'free_play_topic_categories',
	FREE_PLAY_CATEGORY: 'free_play_topic_categories/:categoryId',
	FREE_PLAY_LEVEL: 'user_free_play_topic_category_levels/:levelId',
	FREE_PLAY_EXERCISE: 'free_play_topic_categories/:categoryId/user_learning_path_sections/:id',
	FREE_PLAY_ACHIEVEMENTS: 'free_play_topic_categories/:categoryId/achievements',
	FINISH_FREE_PLAY_EXERCISE:
		'free_play_topic_categories/:categoryId/user_learning_path_sections/:id/finish',
	AI_TUTOR_AUTH_TOKEN: 'authorise_tutor_chat',
	AI_TUTOR_REFRESH_AUTH_TOKEN: 'authorise_tutor_chat/refresh_token',
	YEAR_SUMMARY: 'progress/year_summary',
	BRIDGE_EPISODES: 'study_go_bridge/episodes',
	BRIDGE_ROOM_START: 'study_go_bridge/episodes/rooms/start',
	BRIDGE_ROOM: 'study_go_bridge/episodes/rooms',
	BRIDGE_TASK: 'study_go_bridge/episodes/rooms/:roomId/tasks/:taskType/:id',
	BRIDGE_TASK_FINISH: 'study_go_bridge/episodes/rooms/:roomId/tasks/:taskType/:id/finish',
	BRIDGE_LOCKER_CHECK_PASSWORD: 'study_go_bridge/episodes/:episodeId/lockers/check_password',
	BRIDGE_ROOM_MESSAGES: 'study_go_bridge/episodes/rooms/:roomId/messages',
	BRIDGE_ROOM_MAP: 'study_go_bridge/episodes/rooms/:roomId/map',
};

export const SQULA_ROUTES_API = {
	SQULA_VALIDATE_PARENT_PASSWORD: `${BASE_SQULA_API_URL}/oauth2/validate_parent_password`,
	SQULA_RESET_PASSWORD: `${BASE_SQULA_API_URL}/aanvragen/wachtwoord?action=add_more`,
};

export const getExerciseApiPath = (id: string) => ROUTES_API.EXERCISE.replace(':id', id);

export const getBridgeTaskFinishPath = (roomId: number, taskType: string, taskId: number) =>
	ROUTES_API.BRIDGE_TASK_FINISH.replace(':roomId', String(roomId))
		.replace(':taskType', taskType)
		.replace(':id', String(taskId));

export const getBridgeLockerCheckPasswordPath = (episodeId: number) =>
	ROUTES_API.BRIDGE_LOCKER_CHECK_PASSWORD.replace(':episodeId', String(episodeId));

export const getBridgeRoomMessagesPath = (roomId: number) =>
	ROUTES_API.BRIDGE_ROOM_MESSAGES.replace(':roomId', String(roomId));

export const getBridgeRoomMapPath = (roomId: number) =>
	ROUTES_API.BRIDGE_ROOM_MAP.replace(':roomId', String(roomId));

export const getStoreTimePath = (answerId: string) =>
	ROUTES_API.STORE_TIME.replace(':answerId', answerId);

export const getUpdateUserPath = (userId: string) =>
	ROUTES_API.UPDATE_USER.replace(':userId', userId);

export const finishLearningPathSectionApiPath = (playlistId: string) =>
	ROUTES_API.FINISH_LEARNING_PATH_SECTION.replace(':playlistId', playlistId);

export const getCollectRewardPath = (id: string) => ROUTES_API.COLLECT_REWARD.replace(':id', id);

export const getUpdateRewardPath = (id: string) => ROUTES_API.UPDATE_REWARD.replace(':id', id);

export const getExperimentPath = (experimentName: string) =>
	ROUTES_API.USER_EXPERIMENT.replace(':experimentName', experimentName);

export const getNotificationStatusPath = (notificationId: string) =>
	ROUTES_API.NOTIFICATION_STATUS.replace(':notificationId', notificationId);

export const getAudioPath = (lang: string, word: string) =>
	`${ROUTES_API.GET_AUDIO}?lang=${lang}&word=${word}`;

export const getFreePlayCategoryApiPath = (categoryId: string) =>
	ROUTES_API.FREE_PLAY_CATEGORY.replace(':categoryId', categoryId);

export const getFreePlayLevelApiPath = (levelId: string) =>
	ROUTES_API.FREE_PLAY_LEVEL.replace(':levelId', levelId);

export const getFreePlayExerciseApiPath = (categoryId: string, exerciseId: string) =>
	ROUTES_API.FREE_PLAY_EXERCISE.replace(':categoryId', categoryId).replace(':id', exerciseId);

export const finishFreePlaySectionApiPath = (categoryId: string, exerciseId: string) =>
	ROUTES_API.FINISH_FREE_PLAY_EXERCISE.replace(':categoryId', categoryId).replace(
		':id',
		exerciseId,
	);

export const getFreePlayAchievementsApiPath = (categoryId: string | number) =>
	ROUTES_API.FREE_PLAY_ACHIEVEMENTS.replace(':categoryId', categoryId.toString());

export const WEBSOCKET_CHANNELS = {
	LEARNING_PATH_CHANNEL: 'UserLearningPathChannel',
	LAST_ACTIVE_DEVICE_CHANNEL: 'LastUserActiveDeviceChannel',
};

export const SURVEY_CODES = {
	GENERAL_FEEDBACK: '01JGNTXHJAQ6JM3XD6DSXKMEYJ',
	PROGRESS_FEEDBACK: '01J8HBFP6H652N6PG9MPSN4H6Z',
	QUESTION_FEEDBACK: '01JFCFN3BGMH3XBQDE12CBJDZ7',
	AUTONOMY_EXPERIMENT_FEEDBACK: '01JV4PGAB08JY4NACKPCRGHDBC',
	FINISH_FIRST_FREE_PLAY_QUESTION_SET_FEEDBACK: '01JYK0SDXTRSTYRXWGM40FX8RE',
	GOAL_SETTINGS_TOPICS_FEEDBACK: '01K42Q6YSDF9MB217SFD3THNYG',
};

export const CONFETTI_COLORS = ['#7e5af7', '#0dcfa1', '#ffcf00', '#ff970f', '#19cce9'];

export const learningPathHasGameStep = (learningPath: any) =>
	!!learningPath && learningPath.some((step: any) => !!step.game_id);
